import React from 'react'
import moment from 'moment'
import { MyButton } from '@interstellar-component'
import { AlertCircle, Edit05 } from '@untitled-ui/icons-react'

function formatReviewedAt(iso) {
  if (!iso) return null
  return moment(iso).format('h:mma D MMM YYYY')
}

// Shown in the company "Result" tab when verification_status === 'rejected'.
// Surfaces the CLIK Reviewer's note (verification_note) verbatim — it carries
// the free-text reason plus an "Issues found:" checklist, so we preserve line
// breaks — and a CTA that opens the onboarding wizard in revise-mode to correct
// + resubmit the application.
export default function RejectionPanel({ reason, reviewedAt, onRevise, submitting = false }) {
  const reviewed = formatReviewedAt(reviewedAt)
  const hasReason = typeof reason === 'string' && reason.trim().length > 0

  return (
    <div className="overflow-hidden rounded-xl border border-error/200 bg-white shadow-sm">
      <div className="flex items-center gap-2 border-b border-error/200 bg-error/50 px-5 py-3">
        <AlertCircle className="size-[18px] text-error/600" stroke="currentColor" aria-hidden />
        <h2 className="text-sm-semibold text-error/800">Application rejected</h2>
      </div>
      <div className="flex flex-col gap-4 px-5 py-4">
        <div>
          <h3 className="text-sm-medium text-gray-800">Reviewer note</h3>
          <p className="mt-1 text-xs-regular leading-relaxed text-gray-600">
            The reviewer requested changes before this company can be verified.
            Fix the items below, then resubmit for review.
          </p>
        </div>

        <div className="rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
          <p className="whitespace-pre-line text-sm-regular text-gray-800">
            {hasReason ? reason : 'No reason was provided.'}
          </p>
        </div>

        {reviewed ? (
          <p className="text-xs-regular text-gray-500">Reviewed on {reviewed}</p>
        ) : null}

        <hr className="border-gray-200" />
        <div className="flex justify-end pt-1">
          <MyButton
            color="primary"
            variant="filled"
            size="sm"
            type="button"
            disabled={submitting}
            onClick={onRevise}
          >
            <Edit05 className="size-4" stroke="currentColor" aria-hidden />
            <p className="text-sm-semibold">Revise &amp; Resubmit</p>
          </MyButton>
        </div>
      </div>
    </div>
  )
}
